import { render, staticRenderFns } from "./commonGradeAndClass.vue?vue&type=template&id=772f3ade&scoped=true"
import script from "./commonGradeAndClass.vue?vue&type=script&lang=js"
export * from "./commonGradeAndClass.vue?vue&type=script&lang=js"
import style0 from "./commonGradeAndClass.vue?vue&type=style&index=0&id=772f3ade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772f3ade",
  null
  
)

export default component.exports